import moment from 'moment'

export const formatDateTime = dateTimeString => {
  return moment(dateTimeString).format('DD/MM/YYYY HH:mm')
}

export const formatDate = date => moment(date).format('DD MMM YYYY')

export const stripEmptyParagraphTags = text => {
  return text.replace('<p>&nbsp;</p>', '')
}

export const metresToMiles = meters => (Number(meters) * 0.00062137)?.toFixed(2)
export const kmToMiles = km => (Number(km) * 0.62)?.toFixed(2)
export const formatOpeningTimeDays = openingTimes => {
  const days = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ]
  return !openingTimes
    ? null
    : Object.entries(openingTimes).map(([day_short, times], i) => {
        return {
          day_id: i === 6 ? 0 : i + 1,
          day: days[i],
          day_short,
          ...times,
        }
      })
}

export function debounce(fn, timeout = 10) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, timeout)
  }
}

export const formatAddress = (_, ...values) =>
  [...values]
    .map(item => item?.replace(/\s/g, '+'))
    .filter(Boolean)
    .join('+')

export const formatAtoZAddress = (_, ...values) =>
  [...values].filter(Boolean).join(', ')
